export const theme = {
  colors: {
    primary: '#1a365d',
    primaryHover: '#2c5282',
    text: {
      primary: '#2d3748',
      secondary: '#718096',
      light: '#4a5568'
    },
    background: {
      main: '#ffffff',
      light: '#f7fafc'
    },
    border: '#e2e8f0'
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem'
  },
  borderRadius: {
    sm: '4px',
    md: '8px'
  },
  typography: {
    fontSize: {
      small: '0.875rem',
      regular: '1rem',
      large: '1.25rem',
      xlarge: '1.5rem'
    }
  },
  shadows: {
    hover: '0 4px 6px rgba(0, 0, 0, 0.1)'
  }
};
